module.exports = __webpack_public_path__ + "static/media/arbeit.28f9eadb.jpg";